import { Button } from '@/components/button';
import { FormLabel } from '@/components/form/formlabel';
import { Input } from '@/components/form/input';
import {
  clearErrors,
  getLoginGoogle,
  login,
  loginGoogleCallback,
} from '@/reducers/auth';
import { AppDispatch } from '@/root/store';
import { CheckIcon } from '@heroicons/react/24/solid';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

export function Login() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const scope = searchParams.get('scope');
  const authUser = searchParams.get('authuser');
  const prompt = searchParams.get('prompt');

  const dispatch: AppDispatch = useDispatch();
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });

  const { loading, errorMsg } = useSelector((state: any) => state.auth);

  useEffect(() => {
    if (code) {
      dispatch(loginGoogleCallback(code, scope, authUser, prompt));
    }
  }, [code, scope, authUser, prompt, dispatch]);

  const submit = (e: any) => {
    e.preventDefault();

    dispatch(login(formData.username, formData.password));
  };

  const setData = (e: any, element: string) => {
    setFormData({ ...formData, [element]: e.target.value });

    dispatch(clearErrors());
  };

  const loginGoogleSubmit = () => {
    dispatch(getLoginGoogle());
  };

  return (
    <>
      <div className='text-900 mb-1 text-3xl font-medium'>
        Halo, apa kabar? 👋🏻
      </div>
      <p className={'text-400 mb-4'}>Login di bawah ini untuk akses akun mu</p>
      <form onSubmit={submit}>
        <div>
          <div className='mb-3'>
            <FormLabel label='Username/Email' errorText={errorMsg} required>
              <Input
                type='text'
                onChange={(e) => setData(e, 'username')}
                required
              />
            </FormLabel>
          </div>
          <div className='mb-3'>
            <FormLabel label='Password' required>
              <Input
                type='password'
                onChange={(e) => setData(e, 'password')}
                required
              />
            </FormLabel>
          </div>

          <div className='mb-6 flex justify-end'>
            <a
              href={'reset-password/send-email'}
              className='text-900 ml-2 cursor-pointer text-right font-medium underline'
            >
              Lupa password?
            </a>
          </div>

          <div>
            <Button
              loading={loading === 'manual'}
              type={'submit'}
              className={'w-full'}
              color='neutral'
              leftIcon={<CheckIcon />}
            >
              Masuk
            </Button>
            <Button
              type={'button'}
              onClick={loginGoogleSubmit}
              loading={loading === 'google'}
              variant={'neutral'}
              look={'outline'}
              className={'mt-2 w-full'}
              color='neutral'
              leftIcon={<i className='pi pi-google'></i>}
            >
              Masuk dengan Google
            </Button>
          </div>
        </div>
      </form>
      <div className={'mt-4 text-center'}>
        <span className='text-600 line-height-3 font-medium'>
          Gak punya akun?
        </span>{' '}
        <a href={'register'} className={'font-semibold underline'}>
          Buat yuk!
        </a>
      </div>
    </>
  );
}
